import apiClient from './api';

export default {
  /**
   * Get a specific static page by slug
   * @param {String} slug - Page slug (URL identifier)
   * @returns {Promise} - Axios promise
   */
  getStaticPage(slug) {
    return apiClient.get(`/pages/${slug}/`);
  },
  
  /**
   * Get all static pages
   * @returns {Promise} - Axios promise
   */
  getAllStaticPages() {
    return apiClient.get('/pages/');
  }
}; 